import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const TourPage = lazy(() => import("../pages/tour/page"));
const CartPage = lazy(() => import("../pages/cart/page"));
const CategoryPage = lazy(() => import("../pages/category/page"));
const ReservationsPage = lazy(() => import("../pages/reservations/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
const AboutPage = lazy(() => import("../pages/sobre/page"));
const ContactPage = lazy(() => import("../pages/contato/page"));
const LegalPage = lazy(() => import("../pages/legal/LegalPage"));
const PaymentReturnPage = lazy(() => import("../pages/payment-return/page"));
const TicketPage = lazy(() => import("../pages/ticket/page"));
const GuidesPage = lazy(() => import("../pages/guide/GuidesIndex"));
const GuidePage = lazy(() => import("../pages/guide/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/escunas",
    element: <CategoryPage />,
  },
  {
    path: "/lanchas-privadas",
    element: <CategoryPage />,
  },
  {
    path: "/lanchas-compartilhadas",
    element: <CategoryPage />,
  },
  {
    path: "/passeios-de-jeep",
    element: <CategoryPage />,
  },
  {
    path: "/expedicao-bolivia",
    element: <CategoryPage />,
  },
  {
    path: "/passeios-de-escuna",
    element: <Navigate to="/escunas" replace />,
  },
  {
    path: "/saco-de-mamangua",
    element: <Navigate to="/guia/saco-do-mamangua" replace />,
  },
  {
    path: "/lanchas-e-escunas-privadas",
    element: <Navigate to="/" replace />,
  },
  {
    path: "/passeio/:slug",
    element: <TourPage />,
  },
  {
    path: "/guia",
    element: <GuidesPage />,
  },
  {
    path: "/guia/:slug",
    element: <GuidePage />,
  },
  {
    path: "/carrinho",
    element: <CartPage />,
  },
  {
    path: "/reservas",
    element: <ReservationsPage />,
  },
  {
    path: "/pagamento/retorno",
    element: <PaymentReturnPage />,
  },
  { path: "/ticket", element: <TicketPage /> },
  {
    path: "/sobre-nos",
    element: <AboutPage />,
  },
  {
    path: "/contato",
    element: <ContactPage />,
  },
  {
    path: "/politica-de-privacidade",
    element: <LegalPage type="privacy" />,
  },
  {
    path: "/politica-de-cookies",
    element: <LegalPage type="cookies" />,
  },
  {
    path: "/termos-e-condicoes",
    element: <LegalPage type="terms" />,
  },
  {
    path: "/politica-de-reservas",
    element: <LegalPage type="reservations" />,
  },
  {
    path: "/politica-de-cancelamentos",
    element: <LegalPage type="cancellations" />,
  },
  {
    path: "/termos",
    element: <Navigate to="/termos-e-condicoes" replace />,
  },
  {
    path: "/privacidade",
    element: <Navigate to="/politica-de-privacidade" replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
